export enum UserRole {
    Admin = 'admin',
    Graduated = 'graduated',
    Professor = 'professor',
    Company = 'company'
  }